import styled from "styled-components";
export const MediaStylePicker = styled.div`
    div{
        div{
            grid-template-columns: 150px 150px 150px;
        }
    }
`;

export const ListItem = styled.div`
    position:relative;
    button{
        display: inline-block;
        width: 10%;
        margin: 15px 0px 0px 0px;
        padding: 0px;
        min-width: 10%;
    }
    .ms-TextField
    {
        width: 90%;
        display: inline-block;
    }
    ul
    {
        position: absolute;
        margin: 1px 0px 0px 0px;
        z-index: 10;
        padding: 0px 10px 10px 10px;
        width: 95%;
        background: #F4F8F9;
    }
    li
    {
       
        list-style-type: none;
        margin: 0px;
        padding-top: 10px;
    }

`;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/fieldStyles.ts